import classNames from 'classnames';

import type { Nullable } from 'chaika-frontend-types/backend';

import styles from '../MobileCard.module.scss';

import { Icon, IconType } from '@components/Icon';

export function Agreement(hasAgreement: boolean): Nullable<React.ReactElement<any>> {
    return !hasAgreement ? (
        <div className={classNames([styles.status, styles.agreement])}>
            <Icon type={IconType.INFO} />
        </div>
    ) : null;
}
